import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const projectTechnologyApiUrl = `${baseApiUrl}/api/ProjectTechnology`;

export async function getProjectTechnologies(id) {
  return await httpRequest(fetchProjectTechnologies.bind(this, id));
}
async function fetchProjectTechnologies(id) {
  let config = getHttpHeaders();
  return await axios.get(`${projectTechnologyApiUrl}?ProjetId=${id}`, config);
}
export async function addProjectTehcnology(newprojectTechnology) {
  return await httpRequest(
    postProjectTechnology.bind(this, newprojectTechnology)
  );
}
async function postProjectTechnology(newprojectTechnology) {
  let config = getHttpHeaders();
  return await axios.post(
    `${projectTechnologyApiUrl}`,
    newprojectTechnology,
    config
  );
}

export async function deleteProjectTechnology(projectTechnologyid) {
  return await httpRequest(
    fetchDeleteProjectTechnology.bind(this, projectTechnologyid)
  );
}
async function fetchDeleteProjectTechnology(projectTechnologyid) {
  let config = getHttpHeaders();
  return await axios.delete(
    `${projectTechnologyApiUrl}/${projectTechnologyid}`,
    config
  );
}
